import { useNavigate, useParams } from 'react-router'
import { VenuePickerGate } from './venue-picker-gate'

/**
 * Thin wrapper around `<VenuePickerGate />` for org-level routes that mirror
 * venue-scoped pages. Mounted at `/orgId/<path>` (no serial in URL), it
 * renders the "Choose a venue to continue to {label}" picker; on pick, the
 * user is sent to `/orgId/venues/:serial/<venuePath>` where the real content
 * lives. Same UX as `/square/table-mappings`, one route per venue-only page.
 */
export function VenueGatePage({
  label,
  venuePath,
}: {
  label: string
  venuePath: string
}) {
  const { org_id } = useParams<{ org_id: string }>()
  const navigate = useNavigate()

  function onPick(serial: string) {
    navigate(`/${org_id}/venues/${serial}/${venuePath}`, {
      viewTransition: true,
      replace: true,
    })
  }

  return (
    <main className="flex flex-1 flex-col">
      <VenuePickerGate label={label} onPick={onPick} />
    </main>
  )
}

/**
 * VenueGatePage for parameterised section routes (e.g. the Main Settings
 * sub-nav's `/bookings/settings/main-configuration/:sectionId`). Appends
 * the URL's `:sectionId` to `venueBasePath` so picking a venue lands on
 * the SAME section the user asked for.
 */
export function SectionVenueGatePage({
  label,
  venueBasePath,
}: {
  label: string
  venueBasePath: string
}) {
  const { sectionId } = useParams<{ sectionId: string }>()
  const venuePath = sectionId ? `${venueBasePath}/${sectionId}` : venueBasePath
  return <VenueGatePage label={label} venuePath={venuePath} />
}
